import { __assign, __decorate, __extends, __rest } from "tslib";
import React from 'react';
import { Button } from '@skbkontur/react-ui/components/Button';
import { Gapped } from '@skbkontur/react-ui/components/Gapped';
import { Modal } from '@skbkontur/react-ui/components/Modal';
import { locale } from '@skbkontur/react-ui/lib/locale/decorators';
import { FiasLocaleHelper } from './locale';
var FiasModal = /** @class */ (function (_super) {
    __extends(FiasModal, _super);
    function FiasModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FiasModal.prototype.render = function () {
        var _a = this.props, onClose = _a.onClose, onSave = _a.onSave, children = _a.children, rest = __rest(_a, ["onClose", "onSave", "children"]);
        return (React.createElement(Modal, __assign({ width: 500, onClose: onClose, "data-tid": "fias-modal" }, rest),
            React.createElement(Modal.Header, null, this.locale.modalTitle),
            React.createElement(Modal.Body, null, children),
            React.createElement(Modal.Footer, { panel: true },
                React.createElement(Gapped, null,
                    React.createElement(Button, { size: "medium", use: "primary", onClick: onSave, "data-tid": "fias-button-submit" }, this.locale.modalButtonOk),
                    React.createElement(Button, { size: "medium", onClick: onClose, "data-tid": "fias-button-cancel" }, this.locale.modalButtonCancel)))));
    };
    FiasModal.__KONTUR_REACT_UI__ = 'FiasModal';
    FiasModal.displayName = 'FiasModal';
    FiasModal.defaultProps = {
        onClose: function () { return null; },
        onSave: function () { return null; },
    };
    FiasModal = __decorate([
        locale('Fias', FiasLocaleHelper)
    ], FiasModal);
    return FiasModal;
}(React.Component));
export { FiasModal };
